import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  ModelDto,
  CreateModelDto,
  UpdateModelDto,
  InstantiateModelDto,
  ApplyModelDto,
  ModelsResponse,
  ApplyModelResponse
} from '@maporium-workspace/shared';

@Injectable({ providedIn: 'root' })
export class ModelResource {
  private readonly baseUrl = environment.apiUrl + '/models';

  constructor(private http: HttpClient) {}

  getOne(id: string) {
    return this.http.get<ModelDto>(this.baseUrl + '/' + id);
  }

  getAll(mapId: string) {
    return this.http.get<ModelsResponse>(this.baseUrl + '?mapId=' + mapId);
  }

  getAllForUser(userId: string) {
    return this.http.get<ModelsResponse>(this.baseUrl + '?userId=' + userId + '&scope=user');
  }

  getAllGlobal() {
    return this.http.get<ModelsResponse>(this.baseUrl + '?scope=global');
  }

  create(model: CreateModelDto) {
    return this.http.post<ModelDto>(this.baseUrl, model);
  }

  update(id: string, model: UpdateModelDto) {
    return this.http.put<ModelDto>(this.baseUrl + '/' + id, model);
  }

  delete(modelId: string) {
    return this.http.delete<void>(this.baseUrl + '/' + modelId);
  }

  instantiate(modelId: string, instantiateDto: InstantiateModelDto) {
    return this.http.post<any>(this.baseUrl + '/' + modelId + '/instantiate', instantiateDto);
  }

  apply(modelId: string, applyDto: ApplyModelDto) {
    return this.http.post<ApplyModelResponse>(this.baseUrl + '/' + modelId + '/apply', applyDto);
  }
}